fragment tagDetails on TagType {
  id
  name
  hidden
}
